import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image1 from "../../../../assets/images/Blog54/image1.png";
import image3 from "../../../../assets/images/Blog54/image3.png";
import image4 from "../../../../assets/images/Blog54/image4.png";
import image5 from "../../../../assets/images/Blog54/image5.png";
import image10 from "../../../../assets/images/Blog54/image10.png";
import image13 from "../../../../assets/images/Blog54/image13.png";
import image16 from "../../../../assets/images/Blog54/image16.png";
import image17 from "../../../../assets/images/Blog54/image17.png";
// import image18 from "../../../../assets/images/Blog54/image18.png";
import image32 from "../../../../assets/images/Blog54/image32.png";
import image21 from "../../../../assets/images/Blog54/image21.png";
import image23 from "../../../../assets/images/Blog54/image23.png";
import image38 from "../../../../assets/images/Blog54/image38.png";
import image42 from "../../../../assets/images/Blog54/image42.png";
import image80 from "../../../../assets/images/Blog54/image80.png";
import image82 from "../../../../assets/images/Blog54/image82.png";
import image75 from "../../../../assets/images/Blog54/image75.png";
import image79 from "../../../../assets/images/Blog54/image79.png";
import image74 from "../../../../assets/images/Blog54/image74.png";
import image111 from "../../../../assets/images/Blog54/image111.png";
import image112 from "../../../../assets/images/Blog54/image112.png";
import image110 from "../../../../assets/images/Blog54/image110.png";

const Blog54 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – February 2, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Liquidity Breaks the Calm, Positioning Gets Exposed</p>
        <p>
          Markets enter the week having just experienced their sharpest reminder this year that stability built on leverage and crowded positioning is inherently fragile. What began as routine
          consolidation quickly morphed into a disorderly repricing across metals, volatility products, and selected risk assets, with spillovers felt well beyond their original source.
        </p>
        <p>
          The shift in tone was abrupt, but not random. Participation remained high, yet conviction thinned rapidly once volatility expanded. The events of last week were not driven by deteriorating
          growth data or an earnings collapse, but by liquidity sensitivity finally asserting itself beneath extended trends.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Structure Intact, but No Longer Forgiving</p>
              <p>
                Equity structure remains intact, but the internal message has clearly changed. Markets are no longer advancing on broad momentum. Instead, price action reflects selective
                participation, increasing dispersion, and a growing intolerance for leverage and crowding.
              </p>
              <p>
                The most important development was the violent repricing in precious metals, which acted as the initial stress point. Extreme volatility readings in gold and silver were followed by
                forced selling, triggering a cascade that rippled through systematic positioning and broader risk exposure. This was not a growth shock — it was a
                <span className="highlightedText"> liquidity event.</span>
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt="Friday metals routFriday metals rout"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt="-30% silver day"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image4}
                    alt="silver largest drop since 1802"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image4)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Despite the scale of the move, equities absorbed the shock without structural damage. Headline indices remained resilient, reinforcing that this episode reflected a tightening of risk
                tolerance rather than a wholesale exit from equities. However, the ease with which markets had been advancing has clearly diminished.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt="the drop in context"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Liquidity, Not Rates, Drives Price Action</p>
              <p>
                Policy narratives last week were quickly absorbed into a broader liquidity framework. Market reaction was less about changes to rate expectations and more about uncertainty around
                balance sheet support and the perceived durability of accommodation.
              </p>
              <p>
                The focus shifted toward whether liquidity conditions would remain as supportive as markets had assumed. This reframing mattered most for assets that had benefited from sustained
                inflows and leverage, leaving them vulnerable once confidence wavered.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt="Warsh anti-QE not rate cuts"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image13}
                    alt="the real dot plot is the key"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image13)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Geopolitical developments added background noise, but their market impact remained secondary. The dominant transmission channel into price action was liquidity sensitivity rather than
                headline risk. This distinction is critical: it explains why the sharpest moves occurred in assets with the most extended positioning rather than those most exposed to geopolitical
                narratives.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt="commodity sentiment not over long"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Supportive, but Increasingly Fragile</p>
              <p>
                From a technical perspective, markets remain in an uptrend, but momentum has slowed materially. Recent price action reflects consolidation rather than continuation, with volatility
                expanding from historically compressed levels.
              </p>
              <p>
                Sentiment indicators show a clear reset underway. Gross leverage across hedge funds and systematic strategies remains elevated, but net leverage has declined sharply, indicating that
                risk reduction is occurring through trimming rather than outright liquidation.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt="Equity sentiment still neutral"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>

                <div className="relatedImg">
                  <img
                    src={image32}
                    alt="leverage long but net leverage lower"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image32)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Options markets reinforced this message. Put volume spiked late in the week, suggesting a delayed but meaningful increase in demand for protection. This shift marks a transition from
                complacency to caution, even as headline indices remain near highs.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt="sentiment for next 100 SPX points negative again but too quick?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt="puts coming in may signal pivot back up"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Liquidity Shock, Positioning Reset</p>
              <p>Last week served as a case study in how volatility emerges when leverage and liquidity collide.</p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br>Macro data itself was not the catalyst. Price action was driven by volatility extremes and forced deleveraging rather than new economic information. Services inflation
                    pressures remained evident, while shelter components continued their gradual decline, with lagged effects still feeding into broader inflation measures.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image38}
                        alt="shelter should continue to be lower in CPI/PCE"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image38)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br></br>China-related signals remained mixed. Regional growth pressures and deflationary dynamics persisted, reinforcing concerns around demand and limiting the global growth
                    impulse.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image42}
                        alt="China regions slashing GDP forecasts"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image42)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br></br>Early earnings results remained broadly constructive. Beats continued to outnumber misses, though dispersion increased and tolerance for disappointment narrowed,
                    particularly in sectors sensitive to rates and liquidity.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image80}
                        alt="US Q4 earnings splits"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image80)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image82}
                        alt="beats growing and miss effects lowering"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image82)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities: </span>
                    <br></br>Precious metals experienced one of the most extreme repricings in the dataset. Silver collapsed following ETF dislocations and forced selling, while gold retraced sharply
                    after an extended advance, unwinding excess momentum rather than invalidating the broader structural drivers.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image3}
                      alt="-30% silver day"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image3)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image5}
                      alt=" the drop in context"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image5)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br></br> Crypto assets remained under pressure. Bitcoin extended a multi-month decline, while ETF flows continued to unwind. Price action reflects ongoing deleveraging rather than
                    renewed accumulation.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image75}
                      alt="Bitcoin 4M in a row dow"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image75)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image79}
                      alt="bitcoin ETFs 3m of outflows"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image79)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br></br>Oil prices remained range-bound. Supply considerations and geopolitical risk were offset by softer demand signals, particularly from China, resulting in consolidation
                    rather than directional follow-through.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image74}
                        alt="oil breakout if global demand holds"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image74)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                The coming week is heavily focused on the
                <span className="highlightedText"> US labour market,</span> with a dense run of employment indicators leading into Friday’s payrolls report. With markets already sensitive to liquidity
                and positioning, these releases, alongside scheduled Federal Reserve commentary, carry increased potential to influence rate expectations, volatility, and risk sentiment.
              </p>
              <p className="highlightedText">Monday, February 2</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>US: S&P Global US Manufacturing PMI (Jan, final)</p>
                </li>

                <li className="themesPointer">
                  <p>US: ISM Manufacturing (Jan)</p>
                </li>
                <li className="themesPointer">
                  <p>US: Bostic speaks at the Atlanta Rotary Club</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, February 3</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>US: JOLTS Job Openings (Dec)</p>
                </li>
                <li className="themesPointer">
                  <p>US: Wards Total Vehicle Sales (Jan)</p>
                </li>
                <li className="themesPointer">
                  <p>US: Barkin speaks on the US economy</p>
                </li>

                <li className="themesPointer">
                  <p>US: Bowman in moderated conversation</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, February 4</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>US: MBA Mortgage Applications</p>
                </li>
                <li className="themesPointer">
                  <p>US: ADP Employment Change (Jan)</p>
                </li>
                <li className="themesPointer">
                  <p>US: S&P Global US Services PMI (Jan, final)</p>
                </li>
                <li className="themesPointer">
                  <p>US: ISM Services Index (Jan)</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, February 5</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>US: Initial Jobless Claims</p>
                </li>
                <li className="themesPointer">
                  <p>US: Bostic speaks with the Dean of Clark Atlanta University</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, February 6</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>US: Change in Nonfarm Payrolls (Jan)</p>
                </li>
                <li className="themesPointer">
                  <p>US: Change in Private Payrolls (Jan)</p>
                </li>
                <li className="themesPointer">
                  <p>US: Average Weekly Earnings MoM (Jan)</p>
                </li>
                <li className="themesPointer">
                  <p>US: Average Weekly Hours (Jan)</p>
                </li>
                <li className="themesPointer">
                  <p>US: Unemployment Rate (Jan)</p>
                </li>
                <li className="themesPointer">
                  <p>US: Labour Force Participation Rate (Jan)</p>
                </li>
                <li className="themesPointer">
                  <p>US: University of Michigan Sentiment (Feb, preliminary)</p>
                </li>
                <li className="themesPointer">
                  <p>US: Consumer Credit (Dec)</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image111}
                    alt=" US data week ahead"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image111)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image112}
                    alt="Fed speakers"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image112)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image110}
                    alt="EW 020226"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image110)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Structure Intact, Tolerance for Risk Narrows</p>
              <p>
                Markets remain structurally supported, but last week exposed how sensitive positioning has become as volatility expands and liquidity tightens. Selectivity continues to matter more
                than broad exposure, particularly where crowding has built up.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br>Equity structure remains intact, but leadership is narrow. Gross exposure is high while net leverage has declined, pointing to rotation and trimming rather than broad
                    de-risking. Consolidation remains the dominant pattern, increasing the importance of positioning and timing.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>Precious metals saw a sharp reset driven by volatility extremes, ETF dislocations, and forced selling. The broader
                    framework remains intact, but near-term price action is dominated by positioning repair, keeping volatility elevated.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Crypto continues to lag, with price action reflecting ongoing deleveraging rather than accumulation. Persistent declines
                    and ETF outflows suggest conviction remains uneven and liquidity-sensitive.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br>Liquidity expectations are now the primary macro driver. Market sensitivity last week reflected balance sheet and
                    liquidity concerns rather than growth deterioration, increasing reactivity to shocks.
                  </p>
                </li>
              </ul>

              <p className="highlightedText">The environment remains sensitive to positioning. Stability now depends more on how leverage and liquidity adjust than on continued momentum.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt=" sentiment for next 100 SPX points negative again but too quick?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt="30% silver day"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt="Equity sentiment still neutral"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1ipAoPs147lUKPnibFnuDA3073gZev0q_f0j0MCugmVQ/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
        <hr className="divisionLine" />
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog54;
